import { request, request4, request3} from "@/utils/request";

//  从试卷中添加考生-试卷列表
export const getexamList = data => {
  return request({
    method: "POST",
    url: "/api/Exammanage/examlist/getexamList",
    data
  });
};
// 从试卷中添加考生-获取考生数据
export const getStudentList = data => {
  return request({
    method: "POST",
    url:
      "/api/paperManage/paperStudent/getStudentList",
    data
  });
};
// 获取题型数据
export const getappstyle = data => {
  return request({
    method: "POST",
    url: "/api/papermanage/appstyleapi/getappstyle",
    data
  });
};
// 删除试卷考生
export const examDelete = data => {
  return request({
    method: "POST",
    url: "/api/ksgl/examManager/delete",
    data
  });
};
// 批量删除
export const examDeleteArr = data => {
  return request({
    method: "POST",
    url: "/api/ksgl/examManager/deleteBatch",
    data
  });
};
// 结束考试
export const examManager = data => {
  return request({
    method: "POST",
    url: "/api/ksgl/examManager/lock",
    data
  });
};
// 开启考试
export const ManagerunLock = data => {
  return request({
    method: "POST",
    url: "/api/ksgl/examManager/unLock",
    data
  });
};
// 复制试卷
export const copy = data => {
  return request({
    method: "POST",
    url: "/api/ksgl/examManager/copy",
    data
  });
};
// 复制试卷复制范围
export const randomCopy = data => {
  return request({
    method: "POST",
    url: "/api/examManage/copyExamApi/copyRandExam",
    data
  });
};
// 批改试卷的导出成绩
export const ExamManyScore = data => {
  return request3({
    method: "GET",
    url: `/ExamManyScore/ExamScore.aspx?examIDArr=${data.examIDArr}&userID=${data.userID}`
  });
};
// 批量导出成绩下载
export const sysNoticeList = data => {
  return request({
    method: "POST",
    url: "/api/notice/sysNoticeApi/sysNoticeList",
    data
  });
};
// 成绩管理考生列表
export const ExamDetail = data => {
  return request({
    method: "POST",
    url: "/api/ksgl/examManager/ExamDetail",
    data
  });
};
// 成绩管理考生列表IP
export const getExamUserIP = data => {
  return request({
    method: "POST",
    url: "/api/ksgl/examManager/getExamUserIP",
    data
  });
};
// 成绩管理统计数据
export const census = data => {
  return request({
    method: "POST",
    url: "/api/ksgl/examManager/census",
    data
  });
};
// 成绩管理单个发布成绩
export const publishResult = data => {
  return request({
    method: "POST",
    url: "/api/ksgl/publishresult/publishResult",
    data
  });
};
// 成绩管理一键发布成绩
export const oneKeyPublishResult = data => {
  return request({
    method: "POST",
    url: "/api/ksgl/publishResult/oneKeyPublishResult",
    data
  });
};
// 成绩管理主观题批阅
export const getTKJDTest = data => {
  return request({
    method: "POST",
    url: "/api/ksgl/examManager/getTKJDTest",
    data
  });
};
// 导出所有考生答题详情
// export const exportAnswer = data => {
//   return request3({
//     method: "GET",
//     url: `/khy.aspx?examID=${data.examID}&isAnswer=1&userID=${data.userID}`
//   });
// };
export const exportAnswer = data => {
  return request3({
    method: "GET",
    url: `/export/correcting?examID=${data.examID}&isAnswer=1&userID=${data.userID}`,
    responseType: "blob",
  });
};
// 批改试卷提交成绩
export const updateSubjectiveScore = data => {
  return request({
    method: "POST",
    url:
      "/api/ksgl/publishResult/updateSubjectiveScore",
    data
  });
};
// 批改试卷错答试题
export const studentExamTestUnRight = data => {
  return request({
    method: "POST",
    url:
      "/api/ksgl/examManager/studentExamTestUnRight",
    data
  });
};
// 难易度组卷 ===> 错答试题
export const getPaperTest = data => {
  return request({
    method: "POST",
    url:
      "/api/paperManage_difflevel/getExam/studentExamTestUnRight/getPaperTest",
    data
  });
};
// 考生搜索
export const SearchExam = data => {
  return request({
    method: "POST",
    url:
      "/api/Exammanage/examlist/SearchExam",
    data
  });
};
// 检查试卷名称是否存在
export const examIsExists = data => {
  return request({
    method: "POST",
    url:
      "/api/ksgl/examManager/examIsExists",
    data
  });
};
// 编辑检查试卷名称是否存在  
export const updateExamName = data => {
  return request({
    method: "POST",
    url:
      "/api/examManage/updateExamName/updateExamName",
    data
  });
};
// 批量导出成绩 ==>久庆新接口
export const batchExportExcel = data => {
  return request({
    method: "POST",
    responseType: 'arraybuffer',
    url:
      "/api/Exammanage/examlist/batchExportExcel",
    data
  });
};
// 精准组卷 查询接口 11.21
export const searchApp = data => {
  return request({
    method: "POST",
    url:
      "/api/userAuth/appManage/searchApp",
    data
  });
}